import {
  FeatureRequestStatus,
  FeatureRequestPriority,
} from '../types/model/FeatureRequest';

export { FeatureRequestStatus, FeatureRequestPriority };

export const FEATURE_REQUEST_MAX_ATTACHMENT_SIZE_MB = 10;

export type FeatureRequestAttachmentMetadata = {
  id: string;
  filename: string;
  contentType: string;
  size: number;
};

export type FeatureRequestResponse = {
  id: string;
  summary: string;
  description: string;
  status: FeatureRequestStatus;
  priority: FeatureRequestPriority;
  projectUrn: string;
  componentUrn: string | null;
  requesterRef: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  attachments?: FeatureRequestAttachmentMetadata[];
};

export type PaginatedFeatureRequests = {
  items: FeatureRequestResponse[];
  total: number;
  offset: number;
  limit: number;
};
